import { Chip, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { YardIssueDto } from '../../models/yard-issue.model'

interface Props {
  issue: YardIssueDto
  selectedJourneyId?: number
  onSelect: (journeyId: number) => void
}

export const YardIssueJourneyPicker = ({ issue, selectedJourneyId, onSelect }: Props) => {
  const { t } = useTranslate()

  return (
    <Stack gap={1}>
      <Typography variant='subtitle1'>
        {t('selectContainerToRelocate', 'Select container to relocate')}
      </Typography>
      <Stack direction='row' gap={1} flexWrap='wrap'>
        {issue.conflictingJourneyIds.map((journeyId, idx) => (
          <Chip
            key={journeyId}
            label={issue.containerNumbers[idx] || `Journey ${journeyId}`}
            color={selectedJourneyId === journeyId ? 'primary' : 'default'}
            variant={selectedJourneyId === journeyId ? 'filled' : 'outlined'}
            onClick={() => onSelect(journeyId)}
          />
        ))}
      </Stack>
    </Stack>
  )
}
